import { useQuery } from "@tanstack/react-query";

export interface PublicFeatureFlags {
  portfolioHomepage: boolean;
  propertyRoutes: boolean;
  property2Public: boolean;
  publishedHomeCount: number;
}

const DEFAULT_FLAGS: PublicFeatureFlags = {
  portfolioHomepage: false,
  propertyRoutes: true,
  property2Public: false,
  publishedHomeCount: 1,
};

export function useFeatureFlags(): PublicFeatureFlags {
  const { data } = useQuery<PublicFeatureFlags>({
    queryKey: ["/api/public/flags"],
    staleTime: 60_000,
    retry: 0,
  });
  return data ?? DEFAULT_FLAGS;
}
